import Loading from './loading.vue'


const LoadingPlugin = {
    install(Vue, options) {
        let app = new Vue({
            data: {
                state:0,
            },
            methods: {
                show() {
                    this.state++
                },
                hide() {
                    this.state--
                },
                get_state() {
                    return this.state
                }
            }
        })
        Vue.prototype.$loading = app
        Vue.prototype.$loading_state = app.get_state
        Vue.component('Loading', Loading)
        if (options) {
            app.loadingStore.setOptions(options)
        }
    }
}

export default LoadingPlugin

